import { render, staticRenderFns } from "./FormularEntity.vue?vue&type=template&id=612daf8e&"
import script from "./FormularEntity.vue?vue&type=script&lang=js&"
export * from "./FormularEntity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports